var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[(_vm.$route.name == 'TerminalAnswerScreen'
            || _vm.$route.name == 'TerminalAnswer'|| _vm.$route.name == 'TerminalEnd')?_c('div',[_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.key})],1)]):_c('div',[(_vm.$route.name !== 'ReportPage')?_c('top-bar'):_vm._e(),_c('div',{staticClass:"container"},[(_vm.$route.name !== 'AssessDetail'
              && _vm.$route.name !== 'messagePage' && _vm.$route.name !== 'ReportPage'
        )?_c('slide-bar'):_vm._e(),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.key})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }